import { render, staticRenderFns } from "./StepByStep.vue?vue&type=template&id=2d136ada&"
import script from "./StepByStep.vue?vue&type=script&lang=js&"
export * from "./StepByStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports